import styles from './NoCurrentFloorFacilityPopup.module.scss';

type Props = {
  message: string;
};

const NoCurrentFloorFacilityPopup = ({ message }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>{message}</div>
    </div>
  );
};
export default NoCurrentFloorFacilityPopup;
